import { useEffect, useState } from "react";
import { Routes, Route, useSearchParams } from "react-router-dom";
import OtpCheck from "./components/OtpCheck";
import CompanyIdentification from "./components/CompanyIdentification";
import Summary from "./components/Summary";
import Step from "./components/Step";
import { useTranslation } from "react-i18next";
import EmailVerification from "./components/EmailVerification";
import Failure from "./components/Failure";
import LoaderPage from "./components/LoaderPage";
import { useAppDispatch, useOnboardingId } from "./store/hooks";
import { initParams, setLanguage } from "./store/reducers";
import Success from "./components/Success";
import IdCheck from "./components/IdCheck";
import OpenbankingStart from "./components/OpenbankingStart";
import OpenbankingCallback from "./components/OpenbankingCallback";
import SepaMandate from "./components/SepaMandate";
import SepaMandateCallback from "./components/SepaMandateCallback";
import PayeeVerification from "./components/PayeeVerification";
import IdentityInformation from "./components/IdentityInformation";

function App() {
  const [isLoading, setIsLoading] = useState(true);

  const dispatch = useAppDispatch();
  const { i18n } = useTranslation();
  const [params] = useSearchParams();

  useEffect(() => {
    dispatch(setLanguage(i18n.language || "en"));
    dispatch(
      initParams({
        token: params.get("token"),
        onboardingId: params.get("onboardingId"),
      }),
    );
    setIsLoading(false);
  }, []);

  return isLoading ? (
    <LoaderPage></LoaderPage>
  ) : (
    <>
      <Routes>
        <Route
          path="/"
          element={
            <Step>
              <LoaderPage />
            </Step>
          }
        />
        <Route
          path="/EmailVerification"
          element={
            <Step>
              <EmailVerification />
            </Step>
          }
        />
        <Route path="/OtpCheck" element={<OtpCheck />} />
        <Route
          path="/CompanyIdentification"
          element={
            <Step>
              {" "}
              <CompanyIdentification />{" "}
            </Step>
          }
        />
        <Route
          path="/Agreement"
          element={
            <Step>
              {" "}
              <Summary />{" "}
            </Step>
          }
        />
        <Route
          path="/IdCheck"
          element={
            <Step>
              <IdCheck />
            </Step>
          }
        />
        <Route
          path="/OpenBanking"
          element={
            <Step>
              <OpenbankingStart />
            </Step>
          }
        />
        <Route path="/OpenBankingCallback" element={<OpenbankingCallback />} />
        <Route
          path="/SepaMandate"
          element={
            <Step>
              <SepaMandate />
            </Step>
          }
        />
        <Route
          path="/PayeeVerification"
          element={
            <Step>
              <PayeeVerification />
            </Step>
          }
        />
        <Route path="/SepaMandateCallback" element={<SepaMandateCallback />} />
        <Route
          path="/IdentityInformation"
          element={
            <Step>
              <IdentityInformation />
            </Step>
          }
        />
        <Route path="/Failure" element={<Failure />} />
        <Route path="/*" element={<Failure />} />
        <Route path="/Success" element={<Success />} />
      </Routes>
    </>
  );
}

export default App;
